import { ErrorMessages } from '@platform-workspace/design-system';
import { LibPhoneNumberErrorType } from '@shared/utils/enums';

import { ValidatorsKeys } from '../enums/validators.enum';

export const VALIDATION_MESSAGES = {
  [ValidatorsKeys.Required]: 'errors.required',
  [ValidatorsKeys.MaxLength]: 'errors.maxLength',
  [ValidatorsKeys.MinLength]: 'errors.minLength',
  [ValidatorsKeys.LargeSize]: 'errors.largeSize',
  [ValidatorsKeys.Email]: 'errors.email',
  [ValidatorsKeys.Zipcode]: 'errors.zipCodeNotValid',
  [ValidatorsKeys.Telegram]: 'errors.telegramChannelNotValid',
  [ValidatorsKeys.ForbiddenSymbols]: 'errors.forbiddenSymbols',
  [ValidatorsKeys.UsernameExists]: 'errors.usernameExists',
  [LibPhoneNumberErrorType.NotValid]: 'errors.phoneNumberNotValid',
  [ValidatorsKeys.UniqueName]: 'errors.uniqueName',
  [ValidatorsKeys.MinGreaterThanMax]: 'errors.minGreaterThanMax',
  [ValidatorsKeys.MaxLessThanMin]: 'errors.maxLessThanMin',
  [ValidatorsKeys.Max]: 'errors.max',
  [ValidatorsKeys.Min]: 'errors.min',
  [ValidatorsKeys.Pattern]: 'errors.pattern',
  [ValidatorsKeys.Format]: 'errors.invalidFormat',
  [ValidatorsKeys.InvalidUrl]: 'errors.invalidUrl',
  [ValidatorsKeys.IncorrectFileFormat]: 'errors.fileUploadConstraints',
  [ValidatorsKeys.Range]: 'errors.range',
  [ValidatorsKeys.CompanyName]: 'errors.companyName',
  [ValidatorsKeys.OperatorName]: 'errors.operatorName',
  [ValidatorsKeys.ProviderId]: 'errors.providerId',
  [ValidatorsKeys.ProviderName]: 'errors.providerName',
  [ValidatorsKeys.ProviderIdExists]: 'errors.providerIdExists',
  [ValidatorsKeys.NonDefaultName]: 'errors.nonDefaultValue',
  [ValidatorsKeys.FolderNameExists]: 'errors.folderNameExists',
  [ValidatorsKeys.SectionNameExists]: 'errors.sectionNameExists',
  [ValidatorsKeys.NameMinLength]: 'errors.nameMinLength',
  [ValidatorsKeys.InvalidOperatorKeyFormat]: 'errors.invalidOperatorKeyFormat',
  [ValidatorsKeys.OperatorKeyExists]: 'errors.operatorKeyExists',
  [ValidatorsKeys.UniqueMethod]: 'errors.uniqueMethod',
  [ValidatorsKeys.BrandId]: 'errors.brandId',
  [ValidatorsKeys.InvalidAssetUploadFile]: 'errors.invalidAssetUploadFile',
  [ValidatorsKeys.InvalidAssetUploadFileFormat]: 'errors.invalidAssetUploadFileFormat',
  [ValidatorsKeys.SpribeDomainEmail]: 'errors.spribeDomainEmail',
  [ValidatorsKeys.InvalidJson]: 'errors.pattern',
  [ValidatorsKeys.VendorId]: 'errors.vendorId',
  [ValidatorsKeys.VendorName]: 'errors.vendorName',
  [ValidatorsKeys.ArrayOverlapping]: 'errors.arrayOverlapping',
} satisfies ErrorMessages;
